import { head, keys, map, omit, startCase } from 'lodash';

const formatTableHeaders = (data, removeHeaders) => {
  const formattedTableHeaders = map(keys(omit(head(data), removeHeaders)), startCase);
  return formattedTableHeaders;
};

const removeTypeName = data => map(data, object => omit(object, ['__typename']));

const mapSpacedData = (key, value, boldKey, boldValue) => {
  return {
    key,
    value,
    boldKey,
    boldValue,
  };
};

export { formatTableHeaders, mapSpacedData, removeTypeName };
